const customRules = {
  pageName: 'כללים מותאמים',
  btnCreate: 'הוסף',
  form: {
    header: {
      create: {
        title: 'כללים מותאמים',
      },
      update: {
        title: 'כללים מותאמים',
      },
    },
    information: {
      details: {
        header: 'פרטים',
        fields: {
          name: 'שם',
          type: {
            name: 'סוג',
            values: {
              tripPriority: 'עדיפות נסיעה',
              driverPriority: 'עדיפות נהג',
              passengerPreferences: 'העדפות נוסעים',
            },
          },
          passengerRuleType: {
            name: 'סוג חוק',
            options: {
              passengers: 'נוסעים',
              drivers: 'נהגים',
              vehicles: 'רכבים',
              passengersAndDrivers: 'נוסע ונהגים',
            },
          },
          source: {
            name: 'מקור',
            values: {
              internal: 'פרופילי נוסעים',
              integration: 'הזמנות אורחים',
            },
          },
        },
      },
      preference: {
        header: 'העדפות',
        fields: {
          passenger: 'נוסע',
          passengers: 'נוסעים',
          preferenceType: {
            name: 'סוג העדפה',
            values: {
              rideTogether: 'נסיעה יחד',
              rideApart: 'נסיעה בנפרד',
              preferredDriver: 'Preferred Driver',
              excludedDriver: 'Excluded Driver',
              strictDriver: 'נהג מחמיר',
              preferredVehicle: 'Preferred Vehicle',
              excludedVehicle: 'Excluded Vehicle',
            },
          },
          drivers: 'נהגים',
          driverPreferenceType: {
            name: 'סוג העדפה',
          },
          vehicleBy: {
            name: 'רכב לפי',
            values: {
              makeAndModel: 'יצרן / דגם רכב',
              name: 'שם רכב',
            },
          },
          vehicleMake: 'יצרן רכב',
          vehicleModels: 'דגמי רכב',
          vehicleNames: 'שמות רכבים',
          pickupOrder: {
            name: 'קבע סדר איסוף',
          },
          frequency: {
            name: 'תדירות',
            values: {
              always: 'תמיד',
              specificRange: 'טווח מסוים',
            },
          },
          dateFrom: 'תאריך מ',
          dateTo: 'תאריך עד',
          timeFrom: 'זמן מ',
          timeTo: 'זמן עד',
          weekdays: 'ימי השבוע',
          direction: {
            name: 'כיוון',
            values: {
              both: 'שניהם',
              pickup: 'איסוף',
              dropoff: 'הורדה',
            },
            warningNoLocation: 'אם לא נבחר מיקום, בחירה ב״כיוון: מ-/אל״ תפריד אוטומטית בין מקטע A למקטע B.',
          },
          location: 'מיקום',
        },
        actions: {
          add: 'הוסף העדפה +',
          addPassenger: 'הוסף',
        },
      },
      priority: {
        header: 'רשומה {{count}}',
        recordHeader: 'רשומה',
        scoreLabel: 'ציון',
        fields: {
          attributes: 'מאפיינים',
          areas: 'אזורים',
          profiles: 'פרופילים',
        },
        btnAddPriority: {
          label: 'הוסף רשומה +',
          tooltip: 'הוסף רמת רשומה חדשה',
        },
      },
    },
    footer: {
      btnSubmit: {
        create: 'שמור',
        submitAndCreate: 'שמור והוסף',
        update: 'שמור',
      },
    },
  },
  table: {
    headers: {
      name: 'שם',
      type: 'סוג',
      priority: 'עדיפות',
      record: 'רשומה',
      value: 'ערך',
      score: 'ציון',
      passengerRuleType: 'סוג חוק',
    },
    filters: {
      recordType: 'רשומה',
    },
    actions: {
      delete: {
        header: 'מחק',
        modal: {
          header: 'מחק כללים מותאמים',
          body: 'אתה עומד למחוק {{num}} כללים.',
        },
        toast: {
          success: 'הצלחה!',
          error: 'שגיאה!',
        },
      },
    },
    tabs: {
      tripsRules: 'חוקי נסיעות',
      driversRules: 'כללי נהגים',
      passengersRules: 'העדפות נוסעים',
    },
    toolTip: {
      noPermission: 'פעולה לא מורשית: נדרשת הרשאה',
    },
  },
  create: {
    toastSuccess: 'הצלחה!',
    toastError: 'כשל',
    toastValidationMessage: 'אנא הוסף מאפיינים',
    errorConflict: {
      title: 'התנגשות כללי נוסעים',
      body: 'יש התנגשות עם הכלל שאתה מנסה ליצור. נוסעים אלו כבר משויכים לכלל אחר עבור אותו טווח זמן.',
    },
  },
  edit: {
    toastSuccess: 'הצלחה!',
    toastError: 'כשל',
    toastValidationMessage: 'אנא הוסף מאפיינים',
    errorConflict: {
      title: 'התנגשות כללי נוסעים',
      body: 'יש התנגשות עם הכלל שאתה מנסה לעדכן. נוסעים אלו כבר משויכים לכלל אחר עבור אותו טווח זמן.',
    },
  },
};

export default customRules;
